import React from 'react';
import { motion } from 'framer-motion';
import Icon from './AppIcon';

const DisclaimerBanner = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3, duration: 0.6 }}
      className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-amber-500/90 via-orange-500/90 to-amber-500/90 backdrop-blur-md border-b border-amber-400/50 shadow-lg"
    >
      <div className="container mx-auto px-4 sm:px-6 py-2.5">
        <div className="flex items-center justify-center gap-2 sm:gap-3 text-white">
          <Icon name="AlertTriangle" size={18} className="flex-shrink-0 animate-pulse" />
          <p className="text-xs sm:text-sm md:text-base font-medium text-center">
            <span className="font-bold">🚧 Site Under Construction</span> - All data displayed is for testing and demonstration purposes only
          </p>
          <Icon name="AlertTriangle" size={18} className="flex-shrink-0 animate-pulse hidden sm:block" />
        </div>
      </div>
    </motion.div>
  );
};

export default DisclaimerBanner;